/* 
Object:         User Scheduler
Description:    Logic and events for the module UserScheduler
Used in:        UserScheduler
*/

import * as appsettings from "../appsettings";
import * as form        from "../form";
import * as main        from "../main";
import * as validation  from "../validation";
import * as helpers     from "../helpers";


// temp data scheduler 
let tempData: SchedulerTempData[] = [];

// current state of the mouse button
let mouseDown = 0;

// captured by change event kendo scheduler (start selection)
let selectionChangeStart: Date | null = null;

// captured by change event kendo scheduler (end selection)
let selectionChangeEnd: Date | null = null;

/**
* Hide piket options (function, groups)
*/
function showHidePiketOptions() {
    const selectedTypeOfEdit = Number($("#TypeOfEdit").data("kendoDropDownList").value());

    // Hide values that are not editable.
    // we should not have to do this because in the model we already declared with a tag
    // SEE: https://docs.telerik.com/aspnet-core/html-helpers/layout/form/hidden-fields
    //main.setHideKendoUIFormItem('UserId', false);
    //main.setHideKendoUIFormItem('MyUserId', false);

    main.setHideDivBootstrap('divFunction', false);
    main.setHideDivBootstrap('divAssignedGroups', false);

    if (selectedTypeOfEdit === 3) {
        main.setHideDivBootstrap('divFunction', true);
        main.setHideDivBootstrap('divAssignedGroups', true);
    }
}

/**
* Hide piket options (function, groups)
*/
function hideHiddenFields(): void {

    // Hide values that are not editable.
    // we should not have to do this because in the model we already declared with a tag
    // SEE: https://docs.telerik.com/aspnet-core/html-helpers/layout/form/hidden-fields
    //main.setHideKendoUIFormItem('UserId', false);
    //main.setHideKendoUIFormItem('MyUserId', false);
}

/**
* Get the settings filled in the generated form. 
*/
function GetShiftWorkDaySettings(amountOfDays: number): Array<{ Day: number, MomentNbr: number, TimeFrom: number, TimeTo: number }> {
    const arrFromTo: Array<{ Day: number, MomentNbr: number, TimeFrom: number, TimeTo: number }> = [];

    // Loop through input fields for the repeated moments.
    for (let row = 1; row <= amountOfDays; row++) {

        for (let numMoment = 1; numMoment <= 3; numMoment++) {
            const valueResult = ($("#" + row + "_" + numMoment + "_From").data("kendoTimePicker") != undefined
                && $("#" + row + "_" + numMoment + "_From").data("kendoTimePicker").value() != null
                && $("#" + row + "_" + numMoment + "_To").data("kendoTimePicker") != undefined
                && $("#" + row + "_" + numMoment + "_To").data("kendoTimePicker").value() != null);

            if (valueResult) {
                const obj = {
                    Day: row,
                    MomentNbr: numMoment,
                    TimeFrom: ($("#" + row + "_" + numMoment + "_From").data("kendoTimePicker").value().getHours() * 60) + $("#" + row + "_" + numMoment + "_From").data("kendoTimePicker").value().getMinutes(),
                    TimeTo: ($("#" + row + "_" + numMoment + "_To").data("kendoTimePicker").value().getHours() * 60) + $("#" + row + "_" + numMoment + "_To").data("kendoTimePicker").value().getMinutes()
                };

                arrFromTo.push(obj);
            }
        }
    }

    return arrFromTo;
}

/**
* Post request to the backend to fill a certain day with a value (boolean)
* @param {boolean} available
*/
function _DialogFullDayAvailable(available: boolean): void {
    // Post Data
    $.ajax({
        type: "POST",
        url: appsettings.getUrl("UserScheduler/SetFullDay"),
        data: {
            UserId: Number($("#SelectedUserId").val()),
            SelectedDate: helpers.toLocalISOString(new Date($("#SelectedDate").val() as string)),
            Available: available
        },
        success: function (responseData: responseModel | undefined | null) {
            const popupNotification = $("#popupNotification").kendoNotification().data("kendoNotification");

            if (responseData.Succesfully) {
                popupNotification.show(responseData.Message, "info");
                $("#scheduler").data("kendoScheduler").dataSource.read();   // refresh
            } else {
                popupNotification.show(responseData.Message, "error");
            }
        }
    });
}

/**
* Init form shift for the button. Gets the information already filled (certain settings).
*/
function onFormSubmit_FormPeriod(vm: vmModelUserScheduler): void {
    // Prevent default behaviour
    vm.preventDefault();

    // Post Data
    $.ajax({
        type: "POST",
        url: appsettings.getUrl(vm.model.FormAction as string),
        data: {
            myUserId: vm.model.myUserId,
            UserId: vm.model.UserId,
            From: vm.model.From,
            FromUTCHour: vm.model.FromUTCHour,
            FromUTCMinutes: vm.model.FromUTCMinutes,
            To: vm.model.To,
            ToUTCHour: vm.model.ToUTCHour,
            ToUTCMinutes: vm.model.ToUTCMinutes,
            FromDate: helpers.toLocalISOString(vm.model.FromDate),
            ToDate: helpers.toLocalISOString(vm.model.ToDate),
            ForMonday: vm.model.ForMonday,
            ForTuesday: vm.model.ForTuesday,
            ForWednesday: vm.model.ForWednesday,
            ForThursday: vm.model.ForThursday,
            ForFriday: vm.model.ForFriday,
            ForSaturday: vm.model.ForSaturday,
            ForSunday: vm.model.ForSunday,
            SelectedDays: vm.model.SelectedDays,
            RepeatEveryNumberOfWeeks: vm.model.RepeatEveryNumberOfWeeks,
            TypeOfEdit: vm.model.TypeOfEdit,
            // SelectedFunction: vm.model.SelectedFunction,
            Function: vm.model.Function,
            SelectedGroups: vm.model.SelectedGroups,
            // GroupItemsList: vm.model.GroupItemsList,
            FormAction: vm.model.FormAction
        },

        success: function (responseData: responseModel | undefined | null) {
            form.showServerResponse("formUserScheduler_FormPeriod", responseData, function () { });

            $("#PeriodScheduleWindow").data("kendoWindow").close();
            $("#scheduler").data("kendoScheduler").dataSource.read();
        }
    });
}


/**
* Submit formshift (custom and not handled by the taghelper because of the dynamic generated form and values presented in the form)
*/
function onFormSubmit_FormShift(vm: vmModel): void {
    // Prevent default behaviour
    vm.preventDefault();

    // Post Data
    $.ajax({
        type: "POST",
        url: appsettings.getUrl("UserScheduler/SaveSettingsShifts"),
        data: {
            ShiftWorkID: vm.model.ShiftWorkID,
            UserID: vm.model.UserID,
            AmountOfDays: vm.model.AmountOfDays,
            ShiftType: vm.model.ShiftType,
            StartDate: helpers.toLocalISOString(vm.model.StartDate),
            ShiftWorkDays: GetShiftWorkDaySettings(vm.model.AmountOfDays),
            SchedulerType: 1, // UserScheduler
        },
        success: function (responseData: responseModel | undefined | null) {
            if (responseData.Succesfully) {
                $('#ShiftWorkID').val(responseData.Id);

                // Post Data
                $.ajax({
                    type: "GET",
                    url: appsettings.getUrl("UserScheduler/FormShift?userId=" + Number($("#SelectedUserId").val())),

                    success: function (responseData) {
                        $("#PloegenScheduleWindow").html(responseData);
                    }
                });

                form.showServerResponse("", responseData, function () { });
            } else {
                $('#ShiftWarning').text(responseData.Message)
            }
        }
    });
}


/**
* Init (set all the click events for the buttons and close all windows made initial by the taghelpers)
*/
export function initialize(): void {

    //
    $("#DialogFullDayNotAvailable").data("kendoDialog").close();

    // close just created window's
    $("#PeriodScheduleWindow").data("kendoWindow").close();
    $("#PloegenScheduleWindow").data("kendoWindow").close();

    // button click window
    $("#showPeriodSchedulerDialogBtn").on("click", function () {

        // open the window centered
        $("#PeriodScheduleWindow").data("kendoWindow").center().open();

        // init show hide piket options (function, groups)
        showHidePiketOptions();
    });

    // button click window
    $("#showPloegenSchedulerDialogBtn").on("click", function () {

        // open the window centered
        $("#PloegenScheduleWindow").data("kendoWindow").center().open();

        // init show hide piket options (function, groups)
        hideHiddenFields();

    });

    // button click window
    $("#thisWeekNotAvailableDialogBtn").on("click", function () {

        // open the dialog centered
        $("#DialogFullWeekNotAvailable").data("kendoDialog").open()

    });

    // button click sync pager
    $("#pagerSyncDialogBtn").on("click", function () {
        $.post({
            type: "POST",
            url: appsettings.getUrl("UserScheduler/SyncPager"),
            data: {
                selectedUserId: Number($("#SelectedUserId").val())
            },
            success: function (responseData) {
                var popupNotification = $("#popupNotification").kendoNotification().data("kendoNotification");

                if (responseData.Succesfully) {
                    popupNotification.show(responseData.Message, "info");
                } else {
                    popupNotification.show(responseData.Message, "error");
                }
            }
        });
    });

    // event handlers for mouse button up and down
    document.body.onmousedown = function () {
        mouseDown = 1;
    }

    // event handlers for mouse button up and down
    document.body.onmouseup = function (): void {

        let userId: number = null;      // userid not selected (logged in user will be used if none is given to the server)

        // user selection
        if ($("#SelectedUserId").val() != '') {
            userId = Number($("#SelectedUserId").val());
        }

        // if certain selection + mousebutton was down
        if (mouseDown == 1 && selectionChangeStart != null && selectionChangeEnd != null) {
            const scheduler = $("#scheduler").data("kendoScheduler");
            const tz = (scheduler.options as any).timezone as string | undefined;
            if (!tz) {
                return;
            }

            // create event
            $.post({
                type: "POST",
                url: appsettings.getUrl("UserScheduler/SchedulerCreate"),
                data: {
                    selectedUserId: userId,
                    UTCstart: kendo.timezone.remove(selectionChangeStart, tz).toISOString(),
                    UTCend: kendo.timezone.remove(selectionChangeEnd, tz).toISOString()
                },
                success: function (responseData: responseModel | undefined | null) {
                    const popupNotification = $("#popupNotification").kendoNotification().data("kendoNotification");

                    $("#scheduler").data("kendoScheduler").dataSource.read();   // refresh

                    if (responseData.Succesfully) {
                        popupNotification.show(responseData.Message, "info");   // info
                    }
                    else {
                        popupNotification.show(responseData.Message, "error");
                    }
                }
            });

            // reset vars
            selectionChangeStart = null;
            selectionChangeEnd = null;
        }

        mouseDown = 0;
    }
}

/**
* Init form period in the window with the submit event (custom with the reason of certain logic that is executed to send to the server)
*/
export function initFormPeriod(): void {
    // Form Submit ajax call
    $('#formUserScheduler_FormPeriod').on("submit", function (event: JQuery.Event & { currentTarget: HTMLElement }) {
        // Prevent default
        event.preventDefault();

        // Make model to send.
        let vm: vmModelUserScheduler = new class implements vmModelUserScheduler {
            preventDefault = event.preventDefault;
            model: null;
        };

        // CheckboxGroup
        let monday = false, tuesday = false, wednesday = false, thursday = false, friday = false, saturday = false, sunday = false;
        let data = $('#SelectedDays').data("kendoCheckBoxGroup").value();

        for (let i = 0; i < data.length; i++) {
            switch (data[i]) {
                case "1":
                    monday = true;
                    break;
                case "2":
                    tuesday = true;
                    break;
                case "4":
                    wednesday = true;
                    break;
                case "8":
                    thursday = true;
                    break;
                case "16":
                    friday = true;
                    break;
                case "32":
                    saturday = true;
                    break;
                case "64":
                    sunday = true;
                    break;
            }
        }

        const currentTarget = $(event.currentTarget);
        const fromField = currentTarget.find("#From").data("kendoTimePicker");
        const toField = currentTarget.find("#To").data("kendoTimePicker");
        const from = currentTarget.find("#FromDate");
        const to = currentTarget.find("#ToDate");

        // Model
        vm.model = {
            myUserId: Number(currentTarget.find("#MyUserId").val()),
            UserId: Number(currentTarget.find("#UserId").val()),
            From: from.val(),
            FromUTCHour: fromField.value().getHours(),
            FromUTCMinutes: fromField.value().getMinutes(),
            To: currentTarget.find("#ToDate").val(),
            ToUTCHour: toField.value().getHours(),
            ToUTCMinutes: toField.value().getMinutes(),
            FromDate: from.data("kendoDatePicker").value(),
            ToDate: to.data("kendoDatePicker").value(),
            ForMonday: monday,
            ForTuesday: tuesday,
            ForWednesday: wednesday,
            ForThursday: thursday,
            ForFriday: friday,
            ForSaturday: saturday,
            ForSunday: sunday,
            SelectedDays: currentTarget.find("#SelectedDays").data("kendoCheckBoxGroup").value(),
            RepeatEveryNumberOfWeeks: Number(currentTarget.find("#RepeatEveryNumberOfWeeks").val()),
            TypeOfEdit: Number(currentTarget.find("#TypeOfEdit").val()),
            Function: currentTarget.find("#Function").val(),
            SelectedGroups: currentTarget.find("#SelectedGroups").val(),
            FormAction: currentTarget.find("#FormAction").val()
        };

        // Fire event
        onFormSubmit_FormPeriod(vm);
    });

    $('#formUserScheduler_FormPeriod').kendoValidator(validation.getConfiguration());
}

/**
* Init form shift for the button. Gets the information already filled (certain settings).
*/
export function initFormShiftWork(): void {
    $("#SchedulePlanningButtonLoader").hide();

    $("#SchedulePlanningButton").on("click", function () {
        $("#SchedulePlanningButtonLoader").show();

        // Post Data
        $.ajax({
            type: "POST",
            url: appsettings.getUrl("UserScheduler/PlanShifts"),
            data: {
                ShiftWorkID: -1,
                UserID: Number($("#SelectedUserId").val()),
                AmountOfDays: $("#AmountOfDays").data("kendoNumericTextBox").value(),
                ShiftType: parseInt($("#ShiftType").data("kendoDropDownList").value()),
                StartDate: $("#StartDate").data("kendoDateTimePicker").value().toDateString(),
                ShiftWorkDays: GetShiftWorkDaySettings($("#AmountOfDays").data("kendoNumericTextBox").value()),
                SchedulerType: 1, // UserScheduler
            },
            success: function (responseData: responseModel | undefined | null) {
                if (responseData && responseData.Succesfully) {
                    $("#scheduler").data("kendoScheduler").dataSource.read();   // refresh scheduler

                    $("#SchedulePlanningButtonLoader").hide();
                    $('#ShiftWarning').text("")

                    //Close dialog
                    $("#PloegenScheduleWindow").data("kendoWindow").close();
                } else {
                    $("#SchedulePlanningButtonLoader").hide();
                    $('#ShiftWarning').text(responseData.Message)
                }
            },

            error: function () {
                $("#SchedulePlanningButtonLoader").hide();
            }
        });

    });

    // Form Submit ajax call
    $('#formUserScheduler_FormShift').on("submit", function (event: JQuery.Event & { currentTarget: HTMLElement }) {
        // Prevent default
        event.preventDefault();

        // Make model to send.
        let vm: vmModel = new class implements vmModel {
            preventDefault = event.preventDefault;
            model: null;
        };

        const currentTarget = $(event.currentTarget);

        vm.model = {
            ShiftWorkID: Number($('#ShiftWorkID').val()),
            AmountOfDays: Number(currentTarget.find("#AmountOfDays").val()),
            ShiftType: Number(currentTarget.find("#ShiftType").val()),
            StartDate: currentTarget.find("#StartDate").data("kendoDateTimePicker").value(),
            EndDate: null,
            UserID: Number(currentTarget.find("#UserID").val()),
            IsAdmin: false
        };

        // Fire event
        onFormSubmit_FormShift(vm);
    });

    // Set validation config
    $('#formUserScheduler_FormShift').kendoValidator(validation.getConfiguration());
}

/**
* Show or hide certain options when the type of edit has been changed.
*/
export function onChangeTypeOfEdit(): void {
    showHidePiketOptions();
}

/**
* Submit formshift (custom and not handled by the taghelper because of the dynamic generated form and values presented in the form)
*/
export function scheduler_navigate(e: kendo.ui.SchedulerNavigateEvent): void {
    if (e.view == 'day' && e.date) {
        e.preventDefault();

        // Presentation Dialog
        $("#dateFullDayNotAvailable").html(e.date.toLocaleDateString());
        $("#SelectedDate").val(e.date.toDateString());
        
        // Open dialog
        $("#DialogFullDayNotAvailable").data("kendoDialog").open();
    }
}

/**
* Post Request set full day (whole day available)
*/
export function DialogFullDayAvailable(): void {
    _DialogFullDayAvailable(true);
}

/**
* Post Request set full day (not available)
*/
export function DialogFullDayNotAvailable(): void {
    _DialogFullDayAvailable(false);
}

/**
* Cancel
*/
export function DialogFullDayNotAvailable_onNo(): void {
    // Do nothing ...
}

export function scheduler_onCancel(e: kendo.ui.SchedulerCancelEvent): void {
    // e.event.isNew() is true bij een nieuw (gesleept) event
    // e.event.id is 0 of null bij een nieuw event
    if (e.event.isNew && e.event.isNew()) return; // Geen reload bij nieuw event

    var scheduler = $("#scheduler").data("kendoScheduler");
    scheduler.dataSource.read();
}

export function scheduler_onAdd(e: kendo.ui.SchedulerAddEvent): void {
    e.preventDefault();

    const scheduler = e.sender;
    const tz = (scheduler.options as any).timezone as string | undefined;
    if (!tz) {
        return;
    }

    const now = new Date();
    const event = e.event as AvicSchedulerEvent;

    if (event.end < now) {
        return;
    }

    const start = event.start < now && event.end > now ? now : event.start;

    $.ajax({
        type: "POST",
        url: appsettings.getUrl("UserScheduler/SchedulerCreate"),
        data: {
            selectedUserId: Number($("#SelectedUserId").val()),
            UTCstart: kendo.timezone.remove(start, tz).toISOString(),
            UTCend: kendo.timezone.remove(event.end, tz).toISOString()
        },
        success: function (responseData) {
            form.showResult(responseData);
            $("#scheduler").data("kendoScheduler").dataSource.read();
        }
    });
}

/**
* Selection drag drop mouse
*/
export function scheduler_onChange(e: kendo.ui.SchedulerChangeEvent): void {

    if (mouseDown == 1) {

        // captured by change event kendo scheduler (start selection)
        selectionChangeStart = e.start;

        // captured by change event kendo scheduler (end selection)
        selectionChangeEnd = e.end;
    }
}

export function scheduler_remove(e: kendo.ui.SchedulerRemoveEvent): void {
    e.preventDefault();

    const scheduler = e.sender;
    const tz = (scheduler.options as any).timezone as string | undefined;
    if (!tz) {
        return;
    }

    const now = new Date();
    const event = e.event as AvicSchedulerEvent;

    if (event.end < now) {
        return;
    }

    const start = event.start < now && event.end > now ? now : event.start;

    $.ajax({
        type: "POST",
        url: appsettings.getUrl("UserScheduler/SchedulerDestroy"),
        data: {
            selectedUserId: Number($("#SelectedUserId").val()),
            appointmentTypeId: event.ColorID,
            DBId: event.DBId,
            startUTC: kendo.timezone.remove(start, tz).toISOString(),                            
            endUTC: kendo.timezone.remove(event.end, tz).toISOString()
        },
        success: function (responseData) {
            form.showResult(responseData);
            $("#scheduler").data("kendoScheduler").dataSource.read();
        }
    });
}

/**
* Get additional information for the request scheduler
*/
export function getAdditionalData(): { Start: Date, End: Date } {
    const scheduler = $("#scheduler").data("kendoScheduler");
    const startDate = new Date(scheduler.view().startDate());
    const endDate = new Date(scheduler.view().endDate());

    let startTime = 0;
    let endTime = 0;

    const view = scheduler.view() as any;

    if (view.startTime()) {
        //optionally add startTime / endTime of the view
        startTime = kendo.date.getMilliseconds(view.startTime());
        endTime = kendo.date.getMilliseconds(view.endTime());
        endTime = endTime == 0 ? kendo.date.MS_PER_DAY : endTime;
    }

    const result = {
        Start: new Date(startDate.getTime() - (startDate.getTimezoneOffset() * kendo.date.MS_PER_MINUTE) + startTime),
        End: new Date(endDate.getTime() - (new Date(endDate.getTime() + 86400000).getTimezoneOffset() * kendo.date.MS_PER_MINUTE) + endTime)
    }

    return result;
}

/**
* Get additional information for the request scheduler
* @param {any} e
*/
export function getAdditionalDataUpdate(e: any): void {                                         // deze any laten staan vanwege Kendo inconsistency
    const scheduler = $("#scheduler").data("kendoScheduler");
    const tz = (scheduler.options as any).timezone as string | undefined;
    if (!tz) {
        return;
    }

    for (let i = 0; i < tempData.length; i++) {
        if (e.UniqueIdentifier == tempData[i].UniqueIdentifier) {
            $.ajax({
                type: "POST",
                url: appsettings.getUrl("UserScheduler/SchedulerUpdate"),
                data: {
                    selectedUserId: Number($("#SelectedUserId").val()),
                    appointmentTypeId: tempData[i].appointmentTypeId as number,
                    dBId: tempData[i].dBId as number,
                    UTCstartOld: kendo.timezone.remove(tempData[i].start, tz).toISOString(),
                    UTCendOld: kendo.timezone.remove(tempData[i].end, tz).toISOString(),
                    UTCstartNew: e.Start.toISOString(),
                    UTCendNew: e.End.toISOString()                 
                },
                success: function (responseData) {
                    form.showResult(responseData);
                    $("#scheduler").data("kendoScheduler").dataSource.read();
                }
            });
        }
    }
}


/**
* Get the data from the scheduler when data is loaded into the tempData array. 
*/
export function scheduler_dataBound(): void {

    const scheduler = $("#scheduler").data("kendoScheduler");               
    const data = scheduler.data() as unknown as SchedulerItem[];
    tempData = new Array();

    // copy to a new array
    for (var i = 0; i < data.length; i++) {
        tempData.push({
            UniqueIdentifier: data[i].UniqueIdentifier,
            dBId: data[i].DBId,
            start: data[i].start,
            end: data[i].end,
            appointmentTypeId: data[i].ColorID
        });
    }
}

/**
* Post request for set Full week
*/
export function DialogSetSelectedWeekNotAvailable_onYes(): void {
    // get the scheduler
    const scheduler = $("#scheduler").data("kendoScheduler");

    // start and stop full week
    let start = new Date(scheduler.view().startDate());
    let stop = new Date(scheduler.view().endDate());
    stop.setDate(stop.getDate() + 1);

    // get current datetime
    const current_datetime = new Date();

    // check
    if (current_datetime > start) {
        start = current_datetime;
    }

    // Post Data
    $.ajax({
        type: "POST",
        url: appsettings.getUrl("UserScheduler/SetFullWeek"),
        data: {
            UserId: Number($("#SelectedUserId").val()),
            BeginDay: helpers.toLocalISOString(start),
            EndDay: helpers.toLocalISOString(stop)
        },
        success: function (responseData: responseModel | undefined | null) {
            form.showResult(responseData);
            scheduler.dataSource.read();
        }
    });
}

/**
* Cancel action -> Post request for set Full week
*/
export function DialogSetSelectedWeekNotAvailable_onNo(): void {
    // Do nothing...
}

/**
* Start date. This will change the enddate to a certain date that is logical.
*/
export function startChange(): void {
    const endPicker = $("#ToDate").data("kendoDatePicker");
    let startDate = this.value();

    if (startDate) {
        startDate = new Date(startDate);
        startDate.setDate(startDate.getDate() + 1);
        endPicker.min(startDate);
    }
}

/**
* End date. This will change the startdate to a certain date that is logical.
*/
export function endChange(): void {
    const startPicker = $("#FromDate").data("kendoDatePicker");
    let endDate = this.value();

    if (endDate) {
        endDate = new Date(endDate);
        endDate.setDate(endDate.getDate() - 1);
        startPicker.max(endDate);
    }
}

/**
* Initiate / open form shift.
*/
export function onFormInitiate_FormShift(): void {
    // Do nothing...
}

export function selectedGroupsAssigned_Changed(): void {
    const cbl = $('#SelectedGroups').data("kendoCheckBoxGroup");

    if (cbl != null) {
        const newValue = cbl.value();
        $('#SelectedGroups').val(newValue);
    }
}
